//React imports
import React, {useState, useEffect, useRef} from 'react'
import { useMsal,  } from "@azure/msal-react";
//mui imports
import Alert from '@mui/material/Alert';
//internal reports
import EventAlert from '../components/EventAlert/EventAlert'
import Toast,{type ToastData, Types} from '../components/Toast/Toast'
import ToastList,{type Positions} from '../components/ToastList/ToastList'

import fetchRheoEvents from '../Helper/Fetch/fetchSSE';
import { loginRequest, protectedResources } from "../authConfig"
export interface AlertData {
    message: string;
    value: string;
}

function SSEPage() {
    const { instance, accounts, inProgress } = useMsal();
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [alert, setAlert] = useState(null);
    const [toasts, setToasts] = useState<ToastData[]>([]);
    const [autoClose, setAutoClose] = useState(true)
    const [autoCloseDuration, setAutoCloseDuration] = useState(600);
    const [position, setPosition] = useState<Positions>("top-right");
    const [received, setReceived] = useState(0);
    const [toastCount, setToastCount] = useState(0);
    const toastsRef = useRef<ToastData[]>([]);
    const abortControllerRef = useRef<AbortController>(null);
    

    toastsRef.current = toasts; // Keep the latest toasts in the ref


    //const evtSource = new EventSource('http://localhost:4444/value-stream');
    function createToast(alert:AlertData, type:Types): ToastData {
        return {
            id: Date.now(),
            message: alert.message+" "+alert.value,
            type:type
            
        }
        }
    

    function showToast(alert:AlertData, type:Types) {
        const toast = createToast(alert, type)
        console.log("created toast:", toast)
        console.log("old toasts:", toastsRef.current)
        const newToasts = [...toastsRef.current, toast];
        
        console.log("newToasts:", newToasts)
        setToasts(newToasts);
    
        console.log("toasts:", toasts)
        if (autoClose){
            setTimeout(() => {
                removeToast(toast.id)   
            }, autoCloseDuration*1000);
        }
    }
    function removeToast(id:number){
        console.log("Removing toast with id:", id)
        const newToasts = toastsRef.current.filter(toast => toast.id !== id);
        setToasts(newToasts);
    }
     /*
    useEffect(() => {
    const evtSource = new EventSource('http://localhost:4444/value-stream');
   
    evtSource.addEventListener("value-update",(event)=>{
            //console.log(event)
            if (event.data){
                const data = JSON.parse(event.data)
                setData(data.data)
                setReceived(prev => prev + 1);
            }
        });

    evtSource.addEventListener("value-event",(event)=>{
            //console.log(event)
            if(event.data){
                const alert = JSON.parse(event.data)
                console.log("Alert:",alert)
                setAlert(alert.data)
                console.log("showToast:",alert.data)
                showToast(alert.data, "warning")
                setToastCount(prev => prev + 1);
            }
        })
        return(){

        }
    }, []); */

   /* useEffect (()=>{
        fetchRheoEvents('http://localhost:4444/value-stream', setData, showToast);
    }, []);
    */
    useEffect (()=>{
        abortControllerRef.current = new AbortController()
        console.log("fethcy fetch fetch")
        fetchRheoEvents(request, instance,abortControllerRef.current, 'http://localhost:8080/value-stream');  
        return ( ) => {
            console.log("page closed, cleaning up sse connection...")
            const ctrl = abortControllerRef.current
            console.log("aborting with:", ctrl)
            ctrl.abort()
        }
    }, []);
    
    return (
        <>
        <div>
            <h1>SSE Page</h1>
            {error && <p>Error: {error}</p>}
            {data && <p>Data: {data}</p>}
            <p>Received Events: {received}</p>
            <p>Toasts: {toasts.length}</p>
            <p>Toast Count: {toastCount}</p>
            
        </div>
        <ToastList position={position} data={toasts} removeToast={removeToast} />
        </>
    );
}

export default SSEPage;